/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 7/4/20
 * Time: 5:02 PM
 */

export const SET_AUTH = 'SET_AUTH';
export const SET_USER_TYPE = "SET_USER_TYPE";
